<script lang='ts' setup>
import logo from '@assets/images/logo.svg';
import { computed } from 'vue';
import { getAbsoluteUrlWithAllParams, getLocalePath } from '@/shared/utils/url-paths';

const props = withDefaults(defineProps<{ url?: string }>(), {
  url: '/',
});

const homeUrl = computed(() => {
  try {
    if (props.url === '/') {
      return getAbsoluteUrlWithAllParams(getLocalePath(props.url));
    }
    return getAbsoluteUrlWithAllParams(props.url);
  } catch {
    return props.url;
  }
});
</script>

<template>
  <a class="flow__logo" :href="homeUrl" data-test="logo-link">
    <img :src="logo" alt="logo qic">
  </a>
</template>

<style lang="scss" scoped>
.flow__logo {
  cursor: pointer;
  margin: 40px 0;
  max-height: 36px;
  position: relative;

  .sticker-arrow {
    @include transition;

    will-change: transform;
  }

  img {
    @include mobile-flow {
      max-width: 92px;
      height: auto;
    }
  }

  svg {
    position: absolute;
    top: 5px;
    left: 80px;
    transform: rotate(-8deg);

    @include mobile-flow {
      max-width: 63px;
      height: auto;
      left: 70px;
    }
  }

  @media (width <= $flow-width) {
    max-height: 24px;
    margin: 24px 0;
  }
}
</style>
